<template>
  <section class="app-main">
    <FixedBar :button="['back']"/>
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
    <Footer />
  </section>
</template>

<script>
import lang from '@/options/lang'
import FixedBar from '@/components/public/FixedBar'
import Footer from '@/components/public/Footer'
export default {
  name: 'AppMain',
  components: {
    FixedBar, Footer
  },
  computed: {
    
  }
}
</script>

<style>
.app-main {
  position: relative;
  padding-bottom: 50px;
  font-size: 14px;
}
.padding-container {
  padding:20px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue